const mutations = {
	setStep (state, payload) {
		const forward = payload > state.step
		this._vm.$set(state, 'step', payload)
		this._vm.$set(state, 'forward', forward)
	},
	complete (state, complete = true) {
		this._vm.$set(state, 'complete', Boolean(complete))
	},
	extraFeatures (state, payload) {
		let val = []
		if (-1 === state.extraFeatures.indexOf(payload)) {
			val = [ ...state.extraFeatures, payload ]
		} else {
			val = [ ...state.extraFeatures.filter((v) => {
				return v !== payload
			}) ]
		}

		this._vm.$set(state, 'extraFeatures', val)
	},
	resetState (state, payload) {
		Object.assign(state, payload)
	},
}

export default mutations
